import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface PortfolioComparisonStepProps {
  onContinue: () => void;
}

const PortfolioComparisonStep = ({ onContinue }: PortfolioComparisonStepProps) => {
  return (
    <div className="space-y-4">
      <p className="text-gray-600">Compare your current and optimized portfolios.</p>
      <div className="space-y-4">
        {/* Portfolio comparison visualization will go here */}
        <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
          Portfolio Comparison Chart Placeholder
        </div>

        <div className="pt-6">
          <Button size="lg" className="w-full max-w-md" onClick={onContinue}>
            Continue
            <ChevronRight className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PortfolioComparisonStep;